/**
 * Public configuration for the existing Synphant production surface.
 *
 * These identifiers select public AWS resources; they are not credentials.
 * Keeping them here makes a production build deterministic instead of relying
 * on dynamic Vite environment-key access, which Vite cannot statically replace.
 */
export const productionConfig = {
  cognito: {
    userPoolId: 'us-east-2_nmjb6o4kU',
    userPoolClientId: '73b8bspoa3tvq712hsen4fu4lq',
    webAuthnRelyingPartyId: 'synphant.com',
  },
} as const;
